const hasPostedToday = (songs, userId) => {
  // Helper: format a Date object as YYYY-MM-DD in local time (not UTC)
  const toLocalYMD = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Today in the viewer's local timezone
  const todayLocal = toLocalYMD(new Date());

  const foundSong = songs.find((song) => {
    if (song.userId !== userId) return false;

    // If the backend stored a local date string for the post, prefer it
    if (typeof song.date === 'string' && song.date.length === 10) {
      return song.date === todayLocal;
    }

    // Otherwise, derive a date from a timestamp if present
    let dt = null;
    if (song.timestamp) {
      // Firestore Timestamp instance
      if (typeof song.timestamp.toDate === 'function') {
        dt = song.timestamp.toDate();
      } else if (typeof song.timestamp === 'number') {
        // Heuristic: seconds vs ms
        dt = new Date(song.timestamp > 1e12 ? song.timestamp : song.timestamp * 1000);
      } else if (typeof song.timestamp === 'string') {
        const parsed = new Date(song.timestamp);
        if (!isNaN(parsed)) dt = parsed;
      }
    }

    if (!dt) return false;

    const songLocal = toLocalYMD(dt);
    return songLocal === todayLocal;
  });

  return foundSong || null;
};

export default hasPostedToday;
